import { render, staticRenderFns } from "./OnOffModule.vue?vue&type=template&id=0daabd0d&scoped=true&"
import script from "./OnOffModule.vue?vue&type=script&lang=js&"
export * from "./OnOffModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daabd0d",
  null
  
)

export default component.exports